"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivergeAbilityHandler = exports.DivergeActorAbilityFactory = exports.DivergeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class DivergeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Diverge;
        this.__typeName = "Diverge";
    }
}
exports.DivergeAbilityArgs = DivergeAbilityArgs;
let DivergeActorAbilityFactory = class DivergeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Diverge", "All", 0);
    }
};
DivergeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Diverge")
], DivergeActorAbilityFactory);
exports.DivergeActorAbilityFactory = DivergeActorAbilityFactory;
let DivergeAbilityHandler = class DivergeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const turnCount = container.getActor(ability.invokerId).turnCount;
        const bPower = 100;
        const immediatePower = Math.max(25, Math.round(Math.min(1, (turnCount + 1) / 10) * bPower));
        const dotPower = Math.max(25, (bPower * 2) - immediatePower);
        container.applyProjectileAttacksWithDamage({
            sequence: sequence.pushSequence("parallel"),
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                path: "line",
                type: "GhostlyMissle",
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", immediatePower)
                ]
            })),
            onHit(sequence, _attack, _damages, projectile) {
                container.applyDebuff({
                    sequence: sequence.pushSequence("sequential"),
                    attackerId: ability.invokerId,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.WitheringEffectArgs("Focus", dotPower)
                });
            },
        });
    }
};
DivergeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Diverge)
], DivergeAbilityHandler);
exports.DivergeAbilityHandler = DivergeAbilityHandler;
